import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AllowTransactionsConfiguration = ({ exception, handleChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Text type="titleS">{t('Excepciones para productos no elegibles')}</Text>
      <Text type="bodyMRegular">
        {t('Si un producto no se puede devolver o cambiar por la causa que sea, permitir:')}
      </Text>
      <Styles.CheckboxContainer>
        <Checkbox
          checked={exception?.enabled_for_refunds}
          label={t('Devolverlo')}
          onChange={e => handleChange('enabled_for_refunds', e.target.checked)}
        />
        <Checkbox
          checked={exception?.enabled_for_exchanges}
          label={t('Cambiarlo')}
          onChange={e => handleChange('enabled_for_exchanges', e.target.checked)}
        />
      </Styles.CheckboxContainer>
    </Styles.SectionContainer>
  )
}

AllowTransactionsConfiguration.propTypes = {
  exception: PropTypes.object,
  handleChange: PropTypes.func,
}

export default AllowTransactionsConfiguration
